import { DeviceStorage, Observability, Tracking, } from '@catawiki/runtime-toolkit';
import { USER_LOGGED_IN_KEY } from '../hooks/useIsUserLoggedIn';
function isSafari() {
    return (/AppleWebKit/i.test(navigator.userAgent) &&
        !/Chrome|CriOS|FxiOS|OPiOS|mercury|Edg|Firefox/i.test(navigator.userAgent));
}
export const pushTrackingEvent = ({ event, eventCategory, eventAction, eventLabel, eventCallback, eventPayload, }) => {
    if (!window.dataLayer) {
        Observability.notifyHB(new Error('Unable to track the event. DataLayer not found'), {
            fingerprint: 'google_analytics',
        });
        return;
    }
    const shouldUseEventCallback = Boolean(eventCallback) && !isSafari();
    const data = {
        event,
        eventCategory,
        eventAction,
        ...(eventLabel && { eventLabel }),
        ...(shouldUseEventCallback && { eventCallback }),
        ...eventPayload,
    };
    window.dataLayer.push(data);
    if (isSafari()) {
        eventCallback?.();
    }
};
export var RegistrationDialogueSource;
(function (RegistrationDialogueSource) {
    RegistrationDialogueSource["HEART_BUTTON_TO_FAVOURITE_PAGE"] = "heart_button_to_fave_page";
})(RegistrationDialogueSource || (RegistrationDialogueSource = {}));
export const trackRegistrationDialogueSeen = (source) => {
    if (DeviceStorage.get(USER_LOGGED_IN_KEY) === 'true') {
        return;
    }
    Tracking.pushGATrackingEvent('registration_dialogue_seen_source', {
        source,
    });
};
export const clickRegistrationLinkWithDataLayer = (event, url, source) => {
    if (DeviceStorage.get(USER_LOGGED_IN_KEY) === 'true') {
        return;
    }
    Tracking.clickWithDataLayer(event, url, {
        event: 'registration_dialogue_seen_source',
        source,
    });
};
//# sourceMappingURL=eventTracking.js.map